import React from "react";
import { Button, Col, FormControl, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  PageListBean,
  SalesCommisionTransactionBean,
  SalesCommisionTransactionCriteria,
  SalesCommisionTransactionsInputBean,
  SalesCommissionTransactionPrintRequest,
} from "../ds/ds.js";
import {
  AddIcon,
  ApproveIcon,
  PayIcon,
  PlayIcon,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar, BaseToolBar } from "../modules/BaseModule.js";
import {
  PopupARModule,
  PopupCustomerModule,
  PopupInvoiceModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { InvoiceService } from "../services/InvoiceService.js";
import { ReportService } from "../services/ReportService.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
class SalesCommissionMaintenance extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "SalesCommission Maintainance",
      isShowExecuteButton: true,
      isShowClearErrorButton: false,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowApproveButton: false,
      isShowPayButton: false,
      isShowNewAdjustmentButton: true,
      isShowExitButton: true,
      salesPersonLookupHandler: null,
      salesCommissionDataList: [],
      salesCommissionData: new SalesCommisionTransactionBean(),
      selectedItemList: [],
      error_list: [],
      alertMessage: [],
      alertMessageLvl4: [],
      alertMessageLvl5: [],
      alertMessageLvl6: [],
      alertType: "",
      isShowAlert: false,
      criteria: new SalesCommisionTransactionCriteria(),
      criteriaViewShow: false,
      pageList: new PageListBean(),
      isCommissionDatasFound: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      alertMsg: "",
      success_list: [],
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      isShowARModule: false,
      moduleForPopup: [],
      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      salesPersons: [],
      isShowPaidPopup: false,
      isShowNewAdjustmentPopup: false,
      isShowStatusPopup: false,
      isShowSalesCommPopup: false,
      isShowAdjCommPopup: false,
      commissionInputBean: new SalesCommisionTransactionsInputBean(),
      adjustmentReasons: [],
      salesCommisionTransactionBean: new SalesCommisionTransactionBean(),
      adjustmentReasonLookupHandler: null,
      percentageList: [],
      isShowAlertLvl4: false,
      isShowAlertLvl5: false,
      isShowPassWordPopup: false,
      password: "",
      isShowAlertLvl6: false,
      status: 0,
      isShowAdjStatusPopup: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    let salesPersons = attribute_cache.salesPersons;
    if (salesPersons != null || salesPersons != undefined) {
      salesPersons.map((attr) => {
        this.state.salesPersons.push(attr);
      });
    }

    const adjustmentReasons = new Array();
    if (!isEmptyArray(attribute_cache.periodSalesCommissionAdjustmentReasons))
      adjustmentReasons.push(
        ...attribute_cache.periodSalesCommissionAdjustmentReasons
      );
    this.state.adjustmentReasons = adjustmentReasons;

    this.initLookupHandlers();
    ModuleUtils.getInvoiceStatusList();
     ModuleUtils.getSalesCommisionTransactionStatusList();
    const isPasswordRequired =
      ConfigManager.isPasswordRequiredForSalesCommission();
    this.isPasswordRequired = isPasswordRequired;
  }
  componentDidUpdate() {}
  initLookupHandlers = () => {
    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.state.salesPersons,
      "SalesPerson"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
    let adjustmentReasonLookupHandler = new GenericAttributeLookupHandler(
      this.state.adjustmentReasons,
      "Adjustment Reason"
    );
    this.setState({
      adjustmentReasonLookupHandler: adjustmentReasonLookupHandler,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  inValidAccess = (msg) => {
    let errMsg = "Access Denied";
    errMsg = msg;
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  statusOnChange = (e) => {
    let criteria = this.state.criteria;
    let status = "";
    if (e.target.value == 0) {
      status = "Z";
    } else if (e.target.value == 1) {
      status = "";
    } else if (e.target.value == 2) {
      status = "O";
    } else if (e.target.value == 3) {
      status = "A";
    } else if (e.target.value == 4) {
      status = "F";
    } else if (e.target.value == 5) {
      status = "X";
    }
    criteria.status = status;
    this.setState({ criteria: criteria, status: e.target.value });
  };
  onCommissionChange = (e) => {
    let criteria = this.state.commissionInputBean;
    criteria[e.target.name] = e.target.value;
    this.setState({ commissionInputBean: criteria });
  };
  onCommissionPercentageChange = (e) => {
    let criteria = this.state.salesCommissionData;
    criteria[e.target.name] = e.target.value;
    this.setState({ salesCommissionData: criteria });
  };
  onAdjustmentChange = (e) => {
    let criteria = this.state.salesCommisionTransactionBean;
    criteria[e.target.name] = e.target.value;
    this.setState({ salesCommisionTransactionBean: criteria });
  };
  adjustmentStatusOnChange = (e) => {
    let criteria = this.state.salesCommissionData;
    criteria[e.target.name] = e.target.value;
    this.setState({ salesCommissionData: criteria });
  };
  passwordOnChange = (e) => {
    let password = e.target.value;
    this.setState({ password: password });
  };
  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
  };
  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersons.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      temp_criteria.salesPersonName = salesPersonBean.description;
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ salesPersonList: salesPersonBean });
  };
  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let criteria = this.state.criteria;
      criteria.salesPersonCode = "";
      criteria.salesPersonName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  validatePaymentCriteria = (commissionInputBean) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (isEmptyArray(commissionInputBean.salesCommissionTransctions)) {
      let errMsg = "SalesCommissionTransaction is Empty ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmpty(commissionInputBean.periodStartDate)) {
        let errMsg = "StartDate is Required ";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmpty(commissionInputBean.periodStopDate)) {
        let errMsg = "StopDate is Required ";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmpty(commissionInputBean.checkNumber)) {
        let errMsg = "CheckNumber is Required ";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmpty(commissionInputBean.checkDate)) {
        let errMsg = "CheckDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmpty(commissionInputBean.commissionPaidDate)) {
        let errMsg = "PaymentDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessageLvl5: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  loadPage = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.status = criteria.status === "" ? "Z" : criteria.status;
    this.loadSalesCommissionList(criteria);
  };
  loadSalesCommissionList = (listRequest) => {
    if (SecurityAccessManager.SalesCommissionMaintenance_Accessible()) {
      InvoiceService.getSalesCommissionTransactionAllRecordDetails(
        listRequest,
        this.loadSalesCommissionPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess();
    }
  };
  loadSalesCommissionPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let salesCommissionDataList = new Array();
      if (!isEmptyArray(response.data.result.salesCommissionTransctionBean)) {
        salesCommissionDataList =
          response.data.result.salesCommissionTransctionBean;
        this.setState({
          isShowApproveButton: true,
          isShowPayButton: true,
          isShowNewAdjustmentButton: true,
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isCommissionDatasFound: true,
        salesCommissionDataList: salesCommissionDataList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        selectedItemList: [],
        isShowClearCriteriaButton: false,
        isShowResetButton: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    this.calculateTotals([]);
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  execute = (e) => {
    if (e.detail == 1) {
      let criteria = this.state.criteria;
      if (!isEmpty(criteria.salesPersonCode)) {
        if (this.isPasswordRequired) {
          this.openPassWordPopup();
        } else {
          this.loadPage();
          this.clearError();
        }
      } else {
        let errMsg = "SalesPersonCode is Required";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  openPassWordPopup = () => {
    this.setState({
      isShowPassWordPopup: true,
    });
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new SalesCommisionTransactionCriteria();
    criteria.companyCode = this.companyCode;
    criteria.salesPersonName = "";
    this.setState({
      criteria: criteria,
      salesPersonPageListForAutoCompleteList: new Array(),
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      status: "",
    });
  };
  resetView = () => {
    let criteria = new SalesCommisionTransactionCriteria();
    criteria.companyCode = this.companyCode;
    criteria.salesPersonName = "";
    let commissionInputBean = new SalesCommisionTransactionsInputBean();
    let salesCommisionTransactionBean = new SalesCommisionTransactionBean();
    this.setState({
      criteria: criteria,
      commissionInputBean: commissionInputBean,
      salesCommisionTransactionBean: salesCommisionTransactionBean,
      salesCommissionData: new SalesCommisionTransactionBean(),
      isCommissionDatasFound: false,
      selectedItemList: [],
      salesCommissionDataList: new Array(),
      salesPersonPageListForAutoCompleteList: new Array(),
      isShowApproveButton: false,
      isShowPayButton: false,
      isShowNewAdjustmentButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      status: "",
    });
    this.hideAlertCallBack();
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  openCommissionPercentagePopup = (e,code, rowData) => {
    let salesCommissionData = new SalesCommisionTransactionBean();
    salesCommissionData = rowData;
    if (salesCommissionData.documentType != "ADJUST") {
      this.setState({
        salesCommissionData: salesCommissionData,
        isShowSalesCommPopup: true,
      });
    } else {
      this.setState({
        salesCommissionData: salesCommissionData,
        isShowAdjCommPopup: true,
      });
    }
  };
  openCommissionStatusPopup = (code, rowData) => {
    if (code == "O") {
      this.openCommission_StatusPopup(rowData);
    } else if (code == "A") {
      this.openAdjustment_StatusPopup(rowData);
    }
  };
  openCommission_StatusPopup = (rowData) => {
    let salesCommissionData = new SalesCommisionTransactionBean();
    salesCommissionData = rowData;
    this.setState({
      salesCommissionData: salesCommissionData,
      isShowStatusPopup: true,
    });
  };
  openAdjustment_StatusPopup = (rowData) => {
    let salesCommissionData = new SalesCommisionTransactionBean();
    salesCommissionData = rowData;
    this.setState({
      salesCommissionData: salesCommissionData,
      isShowAdjStatusPopup: true,
    });
  };

  viewSalesModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowSalesModule: true,
        moduleForPopup: (
          <PopupSalesModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowARModule: isOpen,
      isShowSalesModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  paySalesCommission = (e) => {
    if (e.detail == 1) {
      let commissionInputBean = new SalesCommisionTransactionsInputBean();
      let criteria = this.state.criteria;
      commissionInputBean.companyCode = this.companyCode;
      commissionInputBean.salesPersonCode = criteria.salesPersonCode;
      commissionInputBean.salesPersonName = criteria.salesPersonName;
      commissionInputBean.periodStartDate = criteria.startDate;
      commissionInputBean.periodStopDate = criteria.stopDate;
      commissionInputBean.currencyCode = "USD";
      commissionInputBean.commissionPaidDate = criteria.commissionPaidDate;
      commissionInputBean.checkDate = criteria.checkDate;
      commissionInputBean.checkNumber = criteria.checkNumber;
      this.setState({
        commissionInputBean: commissionInputBean,
      },()=>{
        this.calculateTotals(this.state.selectedItemList);
      this.setState({
        isShowPaidPopup: true,
      });
      });
      
    }
  };
  newAdjustmentSalesCommission = (e) => {
    if (e.detail == 1) {
      let salesCommisionTransactionBean = new SalesCommisionTransactionBean();
      this.setState({
        salesCommisionTransactionBean: salesCommisionTransactionBean,
      });
      this.setState({
        isShowNewAdjustmentPopup: true,
      });
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {};
  clearSalesCommData = () => {
    this.setState({
      salesCommissionData: new SalesCommisionTransactionBean(),
    });
  };
  closeAlertModalCallBacklvl5 = (isShowPopup) => {
    // this.clearSalesCommData();
    this.setState({
      isShowSalesCommPopup: isShowPopup,
      isShowAdjCommPopup: isShowPopup,
      isShowStatusPopup: isShowPopup,
      isShowNewAdjustmentPopup: isShowPopup,
      isShowAdjStatusPopup: isShowPopup,
      isShowPaidPopup: isShowPopup,
    });
    this.hideAlertCallBackLvl5();
  };
  closeAlertModalCallBacklvl6 = (isShowPopup) => {
    this.setState({
      isShowPassWordPopup: isShowPopup,
    });
    this.clearPassWord();
    this.hideAlertCallBackLvl6();
  };
  newAdjustmentLine = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Creating new Adjustment Line...",
      });
      let salesCommisionTransactionBean =
        this.state.salesCommisionTransactionBean;
      let criteria = this.state.criteria;
      salesCommisionTransactionBean.companyCode = this.companyCode;
      salesCommisionTransactionBean.documentType = "ADJUST";
      salesCommisionTransactionBean.salesPersonCode = criteria.salesPersonCode;
      salesCommisionTransactionBean.salesPersonName = criteria.salesPersonName;
      salesCommisionTransactionBean.currencyCode = "USD";
      if (SecurityAccessManager.SalesCommissionCreation_Accessible()) {
        InvoiceService.createSalesCommissionTransaction(
          salesCommisionTransactionBean,
          this.newAdjustmentLineResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess("create Access Denied");
      }
    }
  };
  newAdjustmentLineResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null) {
      if (!isEmptyArray(response.data.salesCommissionBean)) {
        this.loadPage();
        this.closeAlertModalCallBacklvl5(false);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  pay = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Paying Sales Commission...",
      });
      let selectedItemList = this.state.selectedItemList;
      let commissionInputBean = this.state.commissionInputBean;
      let criteria = this.state.criteria;
      commissionInputBean.companyCode = this.companyCode;
      commissionInputBean.salesCommissionTransactionCount =
        selectedItemList.length;
      commissionInputBean.salesCommissionTransctions = selectedItemList;
      // commissionInputBean.salesPersonCode = criteria.salesPersonCode;
      // commissionInputBean.salesPersonName = criteria.salesPersonName;
      // commissionInputBean.periodStartDate = criteria.startDate;
      // commissionInputBean.periodStopDate = criteria.stopDate;
      let isValid = false;
      isValid = this.validatePaymentCriteria(commissionInputBean, criteria);
      if (isValid) {
        if (SecurityAccessManager.SalesCommissionPay_Accessible()) {
          InvoiceService.paidSalesCommissionTransaction(
            commissionInputBean,
            this.paySalesCommissionResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess("Pay Access Denied");
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  paySalesCommissionResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && response.data.result != null) {
      this.closeAlertModalCallBacklvl5(false);
      this.loadPage();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  approveSalesCommission = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading...",
      });
      let selectedItemList = this.state.selectedItemList;
      let criteria = new SalesCommisionTransactionsInputBean();
      criteria.companyCode = this.companyCode;
      criteria.salesCommissionTransactionCount = selectedItemList.length;
      criteria.salesCommissionTransctions = selectedItemList;
      if (!isEmptyArray(criteria.salesCommissionTransctions)) {
        if (SecurityAccessManager.SalesCommissionApproval_Accessible()) {
          InvoiceService.approveSalesCommissionTransaction(
            criteria,
            this.approveSalesCommissionResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess("Approval Access Denied");
        }
      } else {
        let errMsg = "No Input SalesCommissions To Approve";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  approveSalesCommissionResponse = (response) => {
    this.handleResponse(response.data);
    this.loadPage();
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewARModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowARModule: true,
          moduleForPopup: (
            <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  salesCommissionLineColumns = () => {
      const columns = new Array();
  
      columns.push(
        new ColumnDefinition()
          .setDetails("Paid", "isActive", false)
          .setInputDetails(
            false,
            false,
            true,
            null,
            this.selectedOnChange,
            null,
          )
          .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 "),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails(
            "Doc#" , "documentNumber",
            true,
          )
           .setClickDetails(true, false, this.viewInvoiceModule, null)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
      );
      // columns.push(
      //   new ColumnDefinition()
      //     .setDetails("Allocated", "isAllocated", true)
      //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
      //     .setInputDetails(
      //       false,
      //       false,
      //       true,
      //       null,
      //       // this.closeOutCheck,
      //       null
      //     )
      //     .setDisabled(true)
      // )
      columns.push(
        new ColumnDefinition()
          .setDetails("Type", "documentType", true)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Doc Date", "entryDate", true,false,true)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("AR#", "accountReceivbaleNumber", true)
           .setClickDetails(true, false, this.viewARModule, null)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      );
        columns.push(
        new ColumnDefinition()
          .setDetails("Trans Date", "transactionDate", true,false,true)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      );

            columns.push(
        new ColumnDefinition()
          .setDetails("Customer", "customerCode", true)
           .setClickDetails(true, false, this.viewCustomerModule, null)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      );
           columns.push(
        new ColumnDefinition()
          .setDetails("CustomerName", "customerName", true)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      );
               columns.push(
        new ColumnDefinition()
          .setDetails("SubTotal", "invoiceSubTotal", true,true)
          .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
      );

           columns.push(
        new ColumnDefinition()
          .setDetails("InvoiceAmt", "invoiceGrandTotalAmount", true,true)
          .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
      );

                 columns.push(
        new ColumnDefinition()
          .setDetails("SubTotal", "invoiceSubTotal", true,true)
          .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
      );

              columns.push(
        new ColumnDefinition()
          .setDetails("DiscAmt", "invoiceDiscountAmount", true,true)
          .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
      );

          columns.push(
        new ColumnDefinition()
          .setDetails("TransAmt", "transactionAmount", true,true)
          .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
      );

         columns.push(
        new ColumnDefinition()
          .setDetails("CustType", "customerType", true)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      );

               columns.push(
        new ColumnDefinition()
          .setDetails("Logistic#", "logisticMethodCode", true)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
      );

          columns.push(
        new ColumnDefinition()
          .setDetails("Comm%", "commissionPercentage", true)
          .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.openCommissionPercentagePopup, null)
      );

                columns.push(
        new ColumnDefinition()
          .setDetails("Comm Amt", "commissionAmount", true,true)
          .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
         // .setStatusDetails(true, this.openCommission_StatusPopup)
      );


            columns.push(
        new ColumnDefinition()
          .setDetails("Status", "status", true)
          .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
         .setStatusDetails(true, this.getCaption)
      );
   
   
   
   
  
      return columns;
    };
    getCaption = (status) => {
      return ModuleUtils.getSalesCommisionTransactionStatusCaption(status);
    };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "Paid",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.selectedOnChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Doc#",
        "documentNumber",
        0,
        true,
        this.viewInvoiceModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Type",
        "documentType",
        0,
        false,
        null,
        false,
        null,
        null,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Doc Date",
        "entryDate",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "AR#",
        "accountReceivbaleNumber",
        0,
        true,
        this.viewARModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Trans Date",
        "transactionDate",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Customer",
        "customerCode",
        0,
        true,
        this.viewCustomerModule,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "CustomerName",
        "customerName",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SubTotal",
        "invoiceSubTotal",
        1,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "InvoiceAmt",
        "invoiceGrandTotalAmount",
        1,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SubTotal",
        "invoiceSubTotal",
        1
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "DiscAmt",
        "invoiceDiscountAmount",
        1,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "TransAmt",
        "transactionAmount",
        1,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Cust.Type",
        "customerType",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Logistic#",
        "logisticMethodCode",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Comm%",
        "commissionPercentage",
        1,
        true,
        this.openCommissionPercentagePopup
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Comm Amt",
        "commissionAmount",
        1,
        false,
        null,
        false,
        null
      )
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "status",
        "status",
        0,
        true,
        this.openCommissionStatusPopup
      )
    );

    return columnList;
  };

  calculateTotals(list) {
    let totalCommissionAmount = 0;
    if (!isEmptyArray(list)) {
      list.map((line) => {
        totalCommissionAmount =
          totalCommissionAmount + parseFloat(line.commissionAmount);
      });
    }
    let commissionInputBean = this.state.commissionInputBean;
    commissionInputBean.totalCommissionAmount = parseFloat(
      totalCommissionAmount
    );
    this.setState({ commissionInputBean: commissionInputBean });
  }
  selectAllItem = (e) => {
    if (e.detail == 1) {
      let list = [];
      list = this.state.salesCommissionDataList;
      list.map((line) => {
        line.isActive = true;
      });
      this.setState({ selectedItemList: list });
      this.calculateTotals(list);
    }
  };
  unSelectAllItem = (e) => {
    if (e.detail == 1) {
      let list = [];
      list = this.state.salesCommissionDataList;
      list.map((line) => {
        line.isActive = false;
      });
      this.setState({ selectedItemList: [] });
      this.calculateTotals([]);
    }
  };

selectedOnChange = (e, rowData) => {
  const checked = e.target.value;

  const salesCommissionDataList = [
    ...this.state.salesCommissionDataList
  ];

  const selectedItemList = [
    ...this.state.selectedItemList
  ];

  // Find the selected row in the main list
  const index = salesCommissionDataList.findIndex(
    (item) => item.lineNumber === rowData.lineNumber
  );

  if (index > -1) {

    // Update only the selected row
    salesCommissionDataList[index].isActive = checked;

if (checked) {

  // Add to selected list if not already selected
  if (
    !selectedItemList.some(
      (item) =>
        item.documentNumber === rowData.documentNumber &&
        item.salesPersonCode === rowData.salesPersonCode
    )
  ) {
    selectedItemList.push(
      salesCommissionDataList[index]
    );
  }

} else {

  // Remove from selected list using both conditions
  const selectedIndex = selectedItemList.findIndex(
    (item) =>
      item.documentNumber === rowData.documentNumber &&
      item.salesPersonCode === rowData.salesPersonCode
  );

  if (selectedIndex > -1) {
    selectedItemList.splice(selectedIndex, 1);
  }
}
  }

  this.setState({
    salesCommissionDataList,
    selectedItemList,
  });

  this.calculateTotals(selectedItemList);
};


  selectedOnChange_old = (e,rowData) => {

    let selectedItemList = this.state.selectedItemList;
    if (rowData.isActive === true) {
      selectedItemList.push(rowData);
      this.setState({ selectedItemList: selectedItemList });
      this.calculateTotals(selectedItemList);
    } else {
      let selectedItemList = this.state.selectedItemList;
      let invList = [];
      for (let item of selectedItemList) {
        if (item.isActive != rowData.isActive) {
          invList.push(item);
          this.setState({ selectedItemList: invList });
          this.calculateTotals(invList);
        } else if (selectedItemList.length == 1) {
          this.setState({ selectedItemList: [] });
          this.calculateTotals([]);
        }
      }
    }
  };
 
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new SalesCommissionTransactionPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating...",
    });
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.SalesCommissionPDF_Report_Accessible()) {
        ReportService.generateSalesCommissionTransactionPrintReport(
          listRequest,
          this.generateReportResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess("PDF Access Denied");
      }
    } else if (reportBean.reportType == 2) {
      if (SecurityAccessManager.SalesCommissionExcel_Report_Accessible()) {
        ReportService.generateSalesCommissionTransactionPrintReport(
          listRequest,
          this.generateReportResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess("Excel Access Denied");
      }
    }
  };
  generateReportResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  updateSalesCommission = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Updating Sales Commission Tracnsaction ...",
      });
      let salesCommissionData = this.state.salesCommissionData;
      salesCommissionData.currencyCode = "USD";
      if (SecurityAccessManager.SalesCommissionUpdation_Accessible()) {
        InvoiceService.updateSalesCommissionTransaction(
          salesCommissionData,
          this.updateCommissionResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess("Update Access Denied");
      }
    }
  };
  updateCommissionResponse = (response) => {
    this.handleResponse(response.data);
    this.closeAlertModalCallBacklvl5(false);
    this.loadPage(1);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  hideAlertCallBackLvl4 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl4: isDisplayed, alertMessageLvl4: [] });
  };
  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl5: isDisplayed, alertMessageLvl5: [] });
  };
  hideAlertCallBackLvl6 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl6: isDisplayed, alertMessageLvl6: [] });
  };
  clearPassWord = () => {
    this.setState({
      password: "",
    });
  };
  validatePassword = (e) => {
    if (e.detail == 1) {
      let password = this.state.password;
      if (!isEmptyString(password)) {
        let dbPassword = ConfigManager.getPasswodForSalesCommission();
        let result = dbPassword.localeCompare(password);
        if (result == 0) {
          this.closeAlertModalCallBacklvl6(false);
          this.loadPage(1);
        } else {
          let errorMsg = "Invalid Password";
          let error_list = [];
          error_list.push(errorMsg);
          this.setState({
            alertMessageLvl6: error_list,
            alertType: "danger",
            isShowAlertLvl6: true,
          });
        }
      } else {
        let errorMsg = "Enter Password";
        let error_list = [];
        error_list.push(errorMsg);
        this.setState({
          alertMessageLvl6: error_list,
          alertType: "danger",
          isShowAlertLvl6: true,
        });
      }
    }
  };
  render() {
    let salesCommissionDataList = this.state.salesCommissionDataList;
    let criteria = this.state.criteria;
    let salesCommissionData = this.state.salesCommissionData;
    let commissionInputBean = this.state.commissionInputBean;
    let salesCommisionTransactionBean =
      this.state.salesCommisionTransactionBean;
    let password = this.state.password;
    const textAreaStyle = {
      maxHeight: "10rem",
      minHeight: "5rem",
      resize: "none",
      padding: "5px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          extend_toolbar={
            <>
              {this.state.isShowExecuteButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.execute(e)}
                >
                  <PlayIcon />
                  Fetch
                </Button>
              )}
            </>
          }
          isShowResetButton={this.state.isShowResetButton}
          pageTitle={this.state.pageTitle}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          clearCriteria={this.clearCriteria}
          reset={this.resetView}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.moduleExit}
        />
        {this.state.isCommissionDatasFound && (
          <BaseToolBar
            extend_toolbar={
              <>
                {this.state.isShowApproveButton && (
                  <Button
                    className="header_buttons secondary"
                    size="sm"
                    onClick={(e) => this.approveSalesCommission(e)}
                  >
                    <ApproveIcon />
                    Approve
                  </Button>
                )}
                {this.state.isShowPayButton && (
                  <Button
                    className="header_buttons secondary"
                    size="sm"
                    onClick={(e) => this.paySalesCommission(e)}
                  >
                    <PayIcon />
                    Pay
                  </Button>
                )}
                {this.state.isShowNewAdjustmentButton && (
                  <Button
                    className="header_buttons secondary"
                    size="sm"
                    onClick={(e) => this.newAdjustmentSalesCommission(e)}
                  >
                    <AddIcon />
                    New Adjustment
                  </Button>
                )}
              </>
            }
          />
        )}
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          statusOnChange={this.statusOnChange}
          salesPersonCodeOnChange={this.salesPersonCodeOnChange}
          salesPersonEnterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
          displayAutoCompleteSalesPersonList={
            this.displayAutoCompleteSalesPersonList
          }
        />
        {this.state.isCommissionDatasFound && (
          <div>
            <Row sm="5">
              <Col className="align-items-left" sm="2">
                <FormLabel>Invoice Commission Lines</FormLabel>
              </Col>
              <Col sm="1">
                <Button
                  sm="2"
                  size="sm"
                  id="fabric_Add_Button"
                  onClick={(e) => this.selectAllItem(e)}
                >
                  {" "}
                  SelectAll{" "}
                </Button>
              </Col>
              <Col sm="2">
                <Button
                  sm="2"
                  size="sm"
                  id="fabric_Add_Button"
                  onClick={(e) => this.unSelectAllItem(e)}
                >
                  {" "}
                  UnSelectAll{" "}
                </Button>
              </Col>
              <Col sm="2">
                <FormLabel>Total Commission Amount</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  value={commissionInputBean.totalCommissionAmount}
                  onChange={this.onCommissionChange}
                  className="summary_input text-right"
                  decimalScale={2}
                  name={"totalCommissionAmount"}
                  disabled={true}
                />
              </Col>
            </Row>
          </div>
        )}
        {this.state.isCommissionDatasFound && (
          <>
            <Row>
              <FormLabel className="label_head">Commissions</FormLabel>
            </Row>
            <div className="mt-3">
                              <CustomTable
                                data={salesCommissionDataList}
                                columns={this.salesCommissionLineColumns()}
                               // enableHighlight={true} // Boolean flag controlling highlight execution
                                //  searchText={pickTicketCriteria.searchName} // Search input text
                              />
                            </div>
            {/* <div className="div_default">
              <EditableDataGrid
                columnsList={this.columnDefinitions()}
                dataList={salesCommissionDataList}
              />
            </div> */}
          </>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowPaidPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel5"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"Payment Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessageLvl5}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl5}
              hideAlertCallBack={this.hideAlertCallBackLvl5}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <div>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.pay(e)}
                >
                  Pay
                </Button>
              </div>
            </div>
          }
          content={
            <div className="">
              <div>
                <Row>
                  <Col sm="2">
                    <FormLabel>Period Start Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      onChange={this.onCommissionChange}
                       name="periodStartDate"
                      value={commissionInputBean.periodStartDate}
                     // disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    <FormLabel>Period Stop Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      onChange={this.onCommissionChange}
                      name="periodStopDate"
                      value={commissionInputBean.periodStopDate}
                      //disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>SalesPerson</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={criteria.salesPersonCode}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      value={criteria.salesPersonName}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel>Total Commission Amt</FormLabel>
                  </Col>
                  <Col className="summary_text_box" sm="4">
                    <InputTextbox
                      value={commissionInputBean.totalCommissionAmount}
                      className="summary_input text-right"
                      disabled={true}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>PaymentDate</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      onChange={this.onCommissionChange}
                      name="commissionPaidDate"
                      value={commissionInputBean.commissionPaidDate}
                      isMandatory={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left" sm="">
                    <FormLabel>Check Details</FormLabel>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Check Number</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      onChange={this.onCommissionChange}
                      name="checkNumber"
                      value={commissionInputBean.checkNumber}
                      isMandatory={true}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    <FormLabel>Check Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      onChange={this.onCommissionChange}
                      name="checkDate"
                      value={commissionInputBean.checkDate}
                      isMandatory={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel>Notes</FormLabel>
                  </Col>
                  <Col sm="10">
                    <textarea
                      style={textAreaStyle}
                      className="form-control"
                      name="remarks"
                      type="text"
                      onChange={this.onCommissionChange}
                      value={commissionInputBean.remarks}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowNewAdjustmentPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel5"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"Adjustment Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <div>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.newAdjustmentLine(e)}
                >
                  create
                </Button>
              </div>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col sm="2">
                  <FormLabel>Period Start Date</FormLabel>
                </Col>
                <Col sm="4">
                  <DatePickerComponent
                    value={criteria.startDate}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="2">
                  <FormLabel>Period Stop Date</FormLabel>
                </Col>
                <Col sm="4">
                  <DatePickerComponent
                    value={criteria.stopDate}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>SalesPerson</FormLabel>
                </Col>
                <Col sm="4">
                  <InputTextbox
                    value={criteria.salesPersonCode}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="6">
                  <InputTextbox
                    value={criteria.salesPersonName}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Adjustment Date</FormLabel>
                </Col>
                <Col sm="4">
                  <DatePickerComponent
                    onChange={this.onAdjustmentChange}
                    name="entryDate"
                    value={salesCommisionTransactionBean.entryDate}
                    isMandatory={true}
                  />{" "}
                </Col>
                <Col sm="2">
                  {" "}
                  <FormLabel>AdjustmentReason Code</FormLabel>
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="adjustmentReasonCode"
                    onChange={this.onAdjustmentChange}
                    value={salesCommisionTransactionBean.adjustmentReasonCode}
                    lookupRequired={true}
                    lookupHandler={this.state.adjustmentReasonLookupHandler}
                    isMandatory={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="">
                  <FormLabel className="label_head">
                    Adjustment Details
                  </FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Adjustment Amount</FormLabel>
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    onChange={this.onAdjustmentChange}
                    name="commissionAmount"
                    className="summary_input"
                    value={salesCommisionTransactionBean.commissionAmount}
                    isMandatory={true}
                  />{" "}
                </Col>
                <Col sm="2">
                  <FormLabel>Status</FormLabel>
                </Col>
                <Col sm="4">
                  <FormControl
                    as="select"
                    custom
                    onChange={this.onAdjustmentChange}
                    name="status"
                    value={salesCommisionTransactionBean.status}
                  >
                    <option value={""}></option>
                    <option value={"O"}>Open</option>
                    <option value={"A"}>Approved</option>
                    <option value={"X"}>Cancelled</option>
                  </FormControl>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  {" "}
                  <FormLabel className="label_head">
                    Adjustment Reason
                  </FormLabel>
                </Col>
                <Col sm="10">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    name="adjustmentRemarks"
                    type="text"
                    onChange={this.onAdjustmentChange}
                    value={salesCommisionTransactionBean.adjustmentRemarks}
                  />
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowSalesCommPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevelX5"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"Commission_Percentage_Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <div>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.updateSalesCommission(e)}
                >
                  Update
                </Button>
              </div>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="2">
                  <FormLabel>Period Start Date</FormLabel>
                </Col>
                <Col sm="4">
                  <DatePickerComponent
                    value={salesCommissionData.startDate}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="2">
                  <FormLabel>Period Stop Date</FormLabel>
                </Col>
                <Col sm="4">
                  <DatePickerComponent
                    value={salesCommissionData.stopDate}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>SalesPerson</FormLabel>
                </Col>
                <Col sm="4">
                  <InputTextbox
                    value={salesCommissionData.salesPersonCode}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="6">
                  <InputTextbox
                    value={salesCommissionData.salesPersonName}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Customer#</FormLabel>
                </Col>
                <Col sm="4">
                  <InputTextbox
                    value={salesCommissionData.customerCode}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="6">
                  <InputTextbox
                    value={salesCommissionData.customerName}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Doc#</FormLabel>
                </Col>
                <Col sm="4">
                  <InputTextbox
                    value={salesCommissionData.documentNumber}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="2">
                  <FormLabel>Document Type</FormLabel>
                </Col>
                <Col sm="4">
                  <InputTextbox
                    value={salesCommissionData.documentType}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Entry Date</FormLabel>
                </Col>
                <Col sm="4">
                  <DatePickerComponent
                    value={salesCommissionData.entryDate}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="2">
                  <FormLabel>Invoice Amount</FormLabel>
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    value={salesCommissionData.invoiceGrandTotalAmount}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>SubTotal Amount</FormLabel>
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    value={salesCommissionData.invoiceSubTotal}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="2">
                  <FormLabel>Transaction Amount</FormLabel>
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    value={salesCommissionData.transactionAmount}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Adjustment Amount</FormLabel>
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    value={salesCommissionData.commissionAmount}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="">
                  <FormLabel className="label_head">
                    Adjustment Details
                  </FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Commission%</FormLabel>
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    onChange={this.onCommissionPercentageChange}
                    name="commissionPercentage"
                    className="summary_input"
                    value={salesCommissionData.commissionPercentage}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  {" "}
                  <FormLabel className="label_head">
                    Adjustment Reason
                  </FormLabel>
                </Col>
                <Col sm="10">
                  <textarea
                    style={textAreaStyle}
                    onChange={this.onCommissionPercentageChange}
                    className="form-control"
                    name="adjustmentRemarks"
                    type="text"
                    value={salesCommissionData.adjustmentRemarks}
                  />
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowAdjCommPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel5"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"Asjustment_Percentage_Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <div>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.updateSalesCommission(e)}
                >
                  Update
                </Button>
              </div>
            </div>
          }
          content={
            <div className="">
              <div>
                <Row>
                  <Col sm="2">
                    <FormLabel>Period Start Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      value={salesCommissionData.startDate}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    <FormLabel>Period Stop Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      value={salesCommissionData.stopDate}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>SalesPerson</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={salesCommissionData.salesPersonCode}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      value={salesCommissionData.salesPersonName}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Adjustment Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      value={salesCommissionData.entryDate}
                      name="entryDate"
                      onChange={this.onCommissionPercentageChange}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    {" "}
                    <FormLabel>AdjustmentReason Code</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="adjustmentReasonCode"
                      onChange={this.onCommissionPercentageChange}
                      value={salesCommissionData.adjustmentReasonCode}
                      lookupRequired={true}
                      lookupHandler={this.state.adjustmentReasonLookupHandler}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left" sm="">
                    <FormLabel className="label_head">
                      Adjustment Details
                    </FormLabel>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Adjustment Amount</FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      onChange={this.onCommissionPercentageChange}
                      name="commissionAmount"
                      className="summary_input"
                      value={salesCommissionData.commissionAmount}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel className="label_head">
                      Adjustment Reason
                    </FormLabel>
                  </Col>
                  <Col sm="10">
                    <textarea
                      style={textAreaStyle}
                      className="form-control"
                      name="adjustmentRemarks"
                      type="text"
                      onChange={this.onCommissionPercentageChange}
                      value={salesCommissionData.adjustmentRemarks}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowStatusPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevelX5"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"Commission Status Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <div>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.updateSalesCommission(e)}
                >
                  Update
                </Button>
              </div>
            </div>
          }
          content={
            <div className="">
              <div>
                <Row>
                  <Col sm="2">
                    <FormLabel>Period Start Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      value={criteria.startDate}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    <FormLabel>Period Stop Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      value={criteria.stopDate}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>SalesPerson</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={criteria.salesPersonCode}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      value={criteria.salesPersonName}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Customer#</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={salesCommissionData.customerCode}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      value={salesCommissionData.customerName}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Document#</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={salesCommissionData.documentNumber}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    <FormLabel>Document Type</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={salesCommissionData.documentType}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Entry Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      value={salesCommissionData.entryDate}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    <FormLabel>Invoice Amount</FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      value={salesCommissionData.invoiceGrandTotalAmount}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>SubTotal Amount</FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      value={salesCommissionData.invoiceSubTotal}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    <FormLabel>Transaction Amount</FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      value={salesCommissionData.transactionAmount}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Adjustment Amount</FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      value={salesCommissionData.commissionAmount}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left" sm="">
                    <FormLabel className="label_head">
                      Adjustment Details
                    </FormLabel>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel>Status</FormLabel>
                  </Col>
                  <Col sm="4">
                    <FormControl
                      as="select"
                      custom
                      name="status"
                      onChange={this.onCommissionPercentageChange}
                      value={salesCommissionData.status}
                    >
                      <option value={"O"}>Open</option>
                      <option value={"A"}>Approved</option>
                      <option value={"X"}>Cancelled</option>
                    </FormControl>
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left" sm="2">
                    <FormLabel className="label_head">
                      Adjustment Reason
                    </FormLabel>
                  </Col>
                  <Col sm="10">
                    <textarea
                      style={textAreaStyle}
                      className="form-control"
                      name="adjustmentRemarks"
                      onChange={this.onCommissionPercentageChange}
                      type="text"
                      value={salesCommissionData.adjustmentRemarks}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowAdjStatusPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevelX5"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"Adjustment Status Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <div>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.updateSalesCommission(e)}
                >
                  Update
                </Button>
              </div>
            </div>
          }
          content={
            <div className="">
              <div>
                <Row>
                  <Col sm="2">
                    <FormLabel>Period Start Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      value={criteria.startDate}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    <FormLabel>Period Stop Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      value={criteria.stopDate}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>SalesPerson</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={criteria.salesPersonCode}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      value={criteria.salesPersonName}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>

                <Row>
                  <Col className="align-items-left" sm="">
                    <FormLabel className="label_head">
                      Adjustment Details
                    </FormLabel>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Adjustment Date</FormLabel>
                  </Col>
                  <Col sm="4">
                    <DatePickerComponent
                      value={salesCommissionData.entryDate}
                      onChange={this.onAdjustmentChange}
                      name="entryDate"
                    />{" "}
                  </Col>
                  <Col sm="2">
                    <FormLabel>Adjustmennt</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      value={salesCommissionData.adjustmentReasonCode}
                      name="adjustmentReasonCode"
                      onChange={this.adjustmentStatusOnChange}
                      lookupRequired={true}
                      lookupHandler={this.state.adjustmentReasonLookupHandler}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel>Status</FormLabel>
                  </Col>
                  <Col sm="4">
                    <FormControl
                      as="select"
                      custom
                      name="status"
                      onChange={this.adjustmentStatusOnChange}
                      value={salesCommissionData.status}
                    >
                      <option value={"O"}>Open</option>
                      <option value={"A"}>Approved</option>
                      <option value={"X"}>Cancelled</option>
                    </FormControl>
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left" sm="2">
                    <FormLabel className="label_head">
                      Adjustment Reason
                    </FormLabel>
                  </Col>
                  <Col sm="10">
                    <textarea
                      style={textAreaStyle}
                      className="form-control"
                      name="adjustmentRemarks"
                      type="text"
                      onChange={this.adjustmentStatusOnChange}
                      value={salesCommissionData.adjustmentRemarks}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowPassWordPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel6"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl6}
          title={"PASSWORD"}
          closeOnDocumentClick={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessageLvl6}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl6}
              hideAlertCallBack={this.hideAlertCallBackLvl6}
            />
          }
          content={
            <div className="">
              <Row>
                <Col>
                  <FormLabel>ENTER THE PASSWORD</FormLabel>
                </Col>
              </Row>
              <Row>
                {" "}
                <Col sm="4">
                  {" "}
                  <FormLabel>PASSWORD : </FormLabel>
                </Col>
                <Col sm="8">
                  <InputTextbox
                    name="password"
                    type="password"
                    value={password}
                    className="password_input"
                    onChange={this.passwordOnChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <Button
                    size="sm"
                    id="fabric_Add_Button"
                    onClick={(e) => this.validatePassword(e)}
                  >
                    continue
                  </Button>
                </Col>
              </Row>
            </div>
          }
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const statusOnChange = (e) => props.statusOnChange(e);
  const status = props.status;
  const salesPersonCodeOnChange = (e) => props.salesPersonCodeOnChange(e);
  const salesPersonEnterKeyEventHandler = (e) =>
    props.salesPersonEnterKeyEventHandler(e);
  const displayAutoCompleteSalesPersonList = (list) =>
    props.displayAutoCompleteSalesPersonList(list);
  let criteria = props.criteria;
  let salesPersonLookupHandler = props.salesPersonLookupHandler;
  let salesPersonCodeRef = React.createRef();
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>SalesPerson</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={salesPersonCodeRef}
            name="salesPersonCode"
            onChange={salesPersonCodeOnChange}
            value={criteria.salesPersonCode}
            lookupRequired={true}
            lookupHandler={salesPersonLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={salesPersonEnterKeyEventHandler}
            autoCompleteListData={props.salesPersonPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteSalesPersonList}
            showAutoCompleteList={props.showAutoCompleteSalesPersonList}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="salesPersonName"
            type="text"
            onChange={onChange}
            value={criteria.salesPersonName}
            readOnly={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Check #</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="checkNumber"
            type="text"
            onChange={onChange}
            value={criteria.checkNumber}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Status</FormLabel>
        </Col>
        <Col sm="2">
          <FormControl
            as="select"
            custom
            onChange={statusOnChange}
            name="status"
            value={status}
          >
            <option value={0}>Open And Approve</option>
            <option value={1}>All</option>
            <option value={2}>Open</option>
            <option value={3}>Approved</option>
            <option value={4}>Paid</option>
            <option value={5}>Cancelled</option>
          </FormControl>
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          {" "}
          <FormLabel>Check Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            onChange={onChange}
            name="checkDate"
            value={criteria.checkDate}
          ></DatePickerComponent>
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Period Start Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="startDate"
            value={criteria.startDate}
            onChange={onChange}
          ></DatePickerComponent>
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Period Stop Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="stopDate"
            value={criteria.stopDate}
            onChange={onChange}
          ></DatePickerComponent>
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Payment Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="commissionPaidDate"
            value={criteria.commissionPaidDate}
            onChange={onChange}
          ></DatePickerComponent>
        </Col>
      </Row>
    </div>
  );
}
function SalesCommissionMaintenanceModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <SalesCommissionMaintenance {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default SalesCommissionMaintenanceModule;
